import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';
export const headerColumnWidth = '160px';
export const cellWidth = '150px';

export const DetailSubContainerStyled = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: ${theme.spacings[400]};
    background-color: ${theme.colors.white};
    border-radius: ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  `};
`;

export const TotalHeaderColumnStyled = styled(Box)`
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[400]};
    width: ${headerColumnWidth};
  `};
`;

export const TotalCellStyled = styled(Box)`
  width: ${cellWidth};
  position: relative;
`;

export const DetailDateHeaderStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `};
`;
